import { FC } from 'react'

import clsx from 'clsx'

import s from './styles.module.scss'
import { CreateObjectPhotoGridItem } from './types'
import { PhotoGridAddSlot, PhotoGridCard, PhotoGridLoadingSlot } from './ui'

const MAX_PHOTOS = 3

interface CreateObjectPhotoGridProps {
  photos: CreateObjectPhotoGridItem[]
  minPhotos?: number
  disabled?: boolean
  className?: string
  uploadInputId: string
  uploadingSlotsCount?: number
  onRemovePhoto?: (id: string) => void
  onPreviewPhoto?: (id: string) => void
}

export const CreateObjectPhotoGrid: FC<CreateObjectPhotoGridProps> = ({
  photos,
  minPhotos = MAX_PHOTOS,
  disabled,
  className,
  uploadInputId,
  uploadingSlotsCount = 0,
  onRemovePhoto,
  onPreviewPhoto,
}) => {
  const visibleItemsCount = photos.length + uploadingSlotsCount
  const emptySlotsCount = Math.max(minPhotos - visibleItemsCount, 0)

  return (
    <div className={clsx(s.grid, className)}>
      {photos.map((photo) => (
        <PhotoGridCard
          key={photo.id}
          photo={photo}
          disabled={disabled}
          onRemovePhoto={onRemovePhoto}
          onPreviewPhoto={onPreviewPhoto}
        />
      ))}

      {Array.from({ length: uploadingSlotsCount }, (_, index) => (
        <PhotoGridLoadingSlot key={`uploading-slot-${index}`} />
      ))}

      {Array.from({ length: emptySlotsCount }, (_, index) => (
        <PhotoGridAddSlot
          key={`slot-${index}`}
          disabled={disabled}
          inputId={uploadInputId}
        />
      ))}
    </div>
  )
}
